import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-90367aac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "usb-manage-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "cm-ui-pb15 cm-ui-pt15" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'usb-manage',
  setup(__props) {

const { t, locale } = useI18n()

const usbManageImages: Record<string, string> = {
  'zh-CN': require('../_assets/zh-CN/usb-manage.png'),
  'zh-TW': require('../_assets/zh-TW/usb-manage.png'),
  'en-US': require('../_assets/en-US/usb-manage.png'),
  'ja-JP': require('../_assets/ja-JP/usb-manage.png'),
}

const bannerImage = computed(() => usbManageImages[locale.value] || usbManageImages['zh-CN'])

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: bannerImage.value,
      width: "240",
      height: "120",
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("strong", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.migrateUsbTip')), 1),
    _createVNode(_component_router_link, { to: "/dashboard/usb-policy" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "cm-ui-mt10",
          style: {"width":"100px"},
          size: "small",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.migrateGoView')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})